import React from 'react';
const getBadgesData = data => {
	let badgeData = <span className="badge bg-info p-2">{data}</span>;
	if (
		data === 'COMPLETED' ||
		data === 'ACTUAL SI' ||
		data === 'ACTUAL VGM' ||
		data === 'FILED BY US' ||
		data === 'FILED BY CUSTOMER' ||
		data === 'SUCCESS' ||
		data === 'CORRECT DATA'
	) {
		badgeData = <span className="badge bg-success p-2">{data}</span>;
	} else if (data === 'IN PROGRESS' || data === 'DUMMY VGM' || data === 'DUMMY SI' || data === 'RUNNING') {
		badgeData = <span className="badge bg-warning p-2">{data}</span>;
	} else if (
		data === 'CANCELED' ||
		data === 'PENDING' ||
		data === 'FAILED' ||
		data === 'WRONG DATA' ||
		data === 'SPOT'
	) {
		badgeData = <span className="badge bg-danger p-2">{data}</span>;
	}
	return badgeData;
};

export default getBadgesData;
